import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { SessionStorageService } from 'ngx-webstorage'; 
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { ICbicDocMst } from 'app/entities/cbic-doc-mst/cbic-doc-mst.model';
import { UtilsService } from 'app/core/util/view-file.component';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';

@Component({
  selector: 'cbic-who-we-are',
  templateUrl: './who-we-are.component.html',
  styleUrls: ['./who-we-are.component.scss']
})
export class WhoWeAreComponent implements OnInit {
  color:any;
  usedLanguage: any;
  // aboutUs

  constructor(private sessionStorageService: SessionStorageService, 
    private httpClient: HttpClient, 
    private contentMstService: CbicContentMstService,
    private changeLnService: ChangeLanguageService, 
    private utils: UtilsService) { }

  ngOnInit(): void {
    this.color = this.sessionStorageService.retrieve('colr');
    this.usedLanguage = this.changeLnService.getLanguage();
  }

  viewFile(doc: ICbicDocMst) {
    let filePath = doc.filePathEn;
    if(this.changeLnService.getLanguage() === 'hi' && doc.filePathHi){
      filePath = doc.filePathHi;
    }
    this.utils.viewOpenning(filePath ?? "");
  }

  getaboutUs() :void{
    this.contentMstService.getContentData('About-Us').subscribe(
      (res : HttpResponse<ICbicContentMst[]>) => {
        if(res.body){
          // this.taxLegislationList = res.body;
        }
      }
    )
}

}
